import './Stack-83ac2229.css';

var classes = {"Stack":"prc-Stack-Stack-WJVsK","StackItem":"prc-Stack-StackItem-CweWT"};

export { classes as default };
